import angular, { auto } from 'angular'

import { RegisterManager } from '../managers/register-manager'
import { UserManager } from '../managers/user-manager'
import { RegistersResource } from '../components/register/registers-resource/registers-resource.service'
import { UsersStore } from '../factories/database/users-store'
import { PriceBookManager } from '../managers/price-book-manager'
import { TaxManager } from '../managers/tax-manager'
import { RetailerSettingsManager } from '../managers/retailer-settings-manager'
import { PosStateManager } from '../managers/pos-state-manager'
import { WebRegisterStatusManager } from '../managers/web-register-status-manager'
import { GiftCardsResource } from '../components/gift-cards/gift-cards-resource/gift-cards-resource.service'
import { SyncManager } from '../managers/sync-manager'
import { ExpeditedSyncManager } from '../managers/sync/expedited-sync-manager'
import { BalancesResource } from '../factories/balance-resource'

/**
 * Managers singleton ES6 instances
 */
export let registerManager: RegisterManager
export let userManager: UserManager
export let registersResource: RegistersResource
export let usersStore: UsersStore
export let priceBookManager: PriceBookManager
export let taxManager: TaxManager
export let retailerSettingsManager: RetailerSettingsManager
export let posStateManager: PosStateManager
export let webRegisterStatusManager: WebRegisterStatusManager
export let giftCardsResource: GiftCardsResource
export let syncManager: SyncManager
export let expeditedSyncManager: ExpeditedSyncManager
export let balancesResource: BalancesResource

angular.module('webregister').run([
  '$injector',
  (i: auto.IInjectorService) => {
    registerManager = i.get('registerManager')
    userManager = i.get('userManager')
    registersResource = i.get('registersResource')
    usersStore = i.get('usersStore')
    posStateManager = i.get('posStateManager')
    taxManager = i.get('taxManager')
    retailerSettingsManager = i.get('retailerSettingsManager')
    webRegisterStatusManager = i.get('webRegisterStatusManager')
    giftCardsResource = i.get('giftCardsResource')
    syncManager = i.get('syncManager')
    priceBookManager = i.get('priceBookManager')
    expeditedSyncManager = i.get('expeditedSyncManager')
    balancesResource = i.get('BalancesResource')
  },
])
